"use client";

import { signIn } from "next-auth/react";
import { TrainingLoader } from "@workspace/ui/common";
import { useEffect, useRef } from "react";

type AutoSignInProps = {
  callbackUrl: string;
};

// Initiates the Keycloak OAuth flow on mount. next-auth v4's signIn() helper
// performs a CSRF POST before redirecting to the provider's authorization
// URL — a server-side redirect() to /api/auth/signin/keycloak can't do that
// (it only GETs the built-in provider-picker page), so this must run
// client-side. The ref guard prevents a double-fire from re-initiating the
// OAuth flow (which would race two authorization-code exchanges).
export function AutoSignIn({ callbackUrl }: AutoSignInProps) {
  const hasFired = useRef(false);

  useEffect(() => {
    if (hasFired.current) return;
    hasFired.current = true;
    void signIn("keycloak", { callbackUrl });
  }, [callbackUrl]);

  return <TrainingLoader />;
}
